/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkflowTasksRouteImport } from './routes/workflow-tasks'
import { Route as NutritionIntakeRouteImport } from './routes/nutrition-intake'
import { Route as DevRouteImport } from './routes/dev'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DevIndexRouteImport } from './routes/dev/index'
import { Route as FormsFormResponseIdRouteImport } from './routes/forms.$formResponseId'
import { Route as DevFormsRouteImport } from './routes/dev/forms'

const WorkflowTasksRoute = WorkflowTasksRouteImport.update({
  id: '/workflow-tasks',
  path: '/workflow-tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const NutritionIntakeRoute = NutritionIntakeRouteImport.update({
  id: '/nutrition-intake',
  path: '/nutrition-intake',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevIndexRoute = DevIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevRoute,
} as any)
const FormsFormResponseIdRoute = FormsFormResponseIdRouteImport.update({
  id: '/forms/$formResponseId',
  path: '/forms/$formResponseId',
  getParentRoute: () => rootRouteImport,
} as any)
const DevFormsRoute = DevFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => DevRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRouteWithChildren
  '/nutrition-intake': typeof NutritionIntakeRoute
  '/workflow-tasks': typeof WorkflowTasksRoute
  '/dev/forms': typeof DevFormsRoute
  '/forms/$formResponseId': typeof FormsFormResponseIdRoute
  '/dev/': typeof DevIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/nutrition-intake': typeof NutritionIntakeRoute
  '/workflow-tasks': typeof WorkflowTasksRoute
  '/dev/forms': typeof DevFormsRoute
  '/forms/$formResponseId': typeof FormsFormResponseIdRoute
  '/dev': typeof DevIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dev': typeof DevRouteWithChildren
  '/nutrition-intake': typeof NutritionIntakeRoute
  '/workflow-tasks': typeof WorkflowTasksRoute
  '/dev/forms': typeof DevFormsRoute
  '/forms/$formResponseId': typeof FormsFormResponseIdRoute
  '/dev/': typeof DevIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dev'
    | '/nutrition-intake'
    | '/workflow-tasks'
    | '/dev/forms'
    | '/forms/$formResponseId'
    | '/dev/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/nutrition-intake'
    | '/workflow-tasks'
    | '/dev/forms'
    | '/forms/$formResponseId'
    | '/dev'
  id:
    | '__root__'
    | '/'
    | '/dev'
    | '/nutrition-intake'
    | '/workflow-tasks'
    | '/dev/forms'
    | '/forms/$formResponseId'
    | '/dev/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DevRoute: typeof DevRouteWithChildren
  NutritionIntakeRoute: typeof NutritionIntakeRoute
  WorkflowTasksRoute: typeof WorkflowTasksRoute
  FormsFormResponseIdRoute: typeof FormsFormResponseIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workflow-tasks': {
      id: '/workflow-tasks'
      path: '/workflow-tasks'
      fullPath: '/workflow-tasks'
      preLoaderRoute: typeof WorkflowTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nutrition-intake': {
      id: '/nutrition-intake'
      path: '/nutrition-intake'
      fullPath: '/nutrition-intake'
      preLoaderRoute: typeof NutritionIntakeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/': {
      id: '/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexRouteImport
      parentRoute: typeof DevRoute
    }
    '/forms/$formResponseId': {
      id: '/forms/$formResponseId'
      path: '/forms/$formResponseId'
      fullPath: '/forms/$formResponseId'
      preLoaderRoute: typeof FormsFormResponseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/forms': {
      id: '/dev/forms'
      path: '/forms'
      fullPath: '/dev/forms'
      preLoaderRoute: typeof DevFormsRouteImport
      parentRoute: typeof DevRoute
    }
  }
}

interface DevRouteChildren {
  DevFormsRoute: typeof DevFormsRoute
  DevIndexRoute: typeof DevIndexRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevFormsRoute: DevFormsRoute,
  DevIndexRoute: DevIndexRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DevRoute: DevRouteWithChildren,
  NutritionIntakeRoute: NutritionIntakeRoute,
  WorkflowTasksRoute: WorkflowTasksRoute,
  FormsFormResponseIdRoute: FormsFormResponseIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
